export default __webpack_public_path__ + "static/media/bg-player.ab6b2e90.jpeg";